// extracted by mini-css-extract-plugin
module.exports = {"root":"ModifySelectedRooms_root__2nFMj","closeButton":"ModifySelectedRooms_closeButton__2l8kT"};